import { useState } from 'react';
import type { Product, ProductClickHandler } from '../../types';
import {
  bucketProducts,
  filterBySearch,
  toDisplayProducts,
  type ViewMode,
} from '../../lib/products';
import { ProductLane } from '../ProductLane/ProductLane';
import { Toolbar } from '../Toolbar/Toolbar';
import styles from './CustomerView.module.css';

/** Customer showcase: search + view toggle over three swimlanes. */
export function CustomerView({
  products,
  onProductClick,
}: {
  products: Product[];
  onProductClick?: ProductClickHandler;
}) {
  const [search, setSearch] = useState('');
  const [viewMode, setViewMode] = useState<ViewMode>('category');

  const filtered = filterBySearch(toDisplayProducts(products, viewMode), search);
  const buckets = bucketProducts(filtered);

  return (
    <>
      <Toolbar
        search={search}
        onSearchChange={setSearch}
        count={filtered.length}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
      />
      <div className={styles.lanes}>
        <ProductLane
          title={'Your Products'}
          products={buckets.licensed}
          onProductClick={onProductClick}
        />
        <ProductLane
          title={'Recommended for You'}
          subtitle={'Products popular in your industry that could add value to your workflow.'}
          products={buckets.recommended}
          onProductClick={onProductClick}
        />
        <ProductLane
          title={'Other Products'}
          products={buckets.other}
          collapsible
          onProductClick={onProductClick}
        />
      </div>
    </>
  );
}
